import { EffectsModule } from '@ngrx/effects';
import { AppCoreEffects } from './app-core/app-core.effects';
import { RouterEffects } from './router-store/router.effects';
import { AuthEffects } from '@store/auth/auth.effects';
import { SettingsEffects } from '@store/settings/settings.effects';

export const AppEffectsModules = EffectsModule.forRoot([AppCoreEffects, RouterEffects, AuthEffects, SettingsEffects]);
